export const schoolRouteEventColor = "warning";
export const scheduleEventColor = "accent";
export const scheduleConflictEventColor = "error";
